const commonParser = require('./dynpack_common');

function getPriceDiscountData(isShow, result) {
    return commonParser.getPriceDiscountData({
        pricePerPassengerWithoutDiscount: Odigeo._.get(result, 'dynpackFareDiscountDetails.pricePerPassengerWithoutDiscount'),
        discountPercentage: Odigeo._.get(result, 'dynpackFareDiscountDetails.discountPercentage'),
        price: result.priceByProduct,
        dynpackFare: result.accommodationDeal.dynpackFare,
        hasInfoDiscount: result.accommodationDeal.dynpackFare,
    });
}

function getFilterTagsData(model) {
    const activatedTags = model.get('activatedTags');
    const numFilteredResults = model.get('numFilteredResults');

    return {
        filterTags: model.get('activatedTags'),
        numResults: model.get('numResults'),
        numFilteredResults: numFilteredResults,
        hasSeveralActivatedTags: Odigeo._.gt(Odigeo._.size(activatedTags), 1),
        hasFilteredResults: !Odigeo._.isEqual(numFilteredResults, 0),
    };
}

function getResultData(model, result) {
    const {accommodationDeal, accommodationInfo, bestDeal} = result;
    const hasBoardType = commonParser.isValidHotelData(accommodationDeal.boardType);
    const isRoomOnly = Odigeo._.isEqual(accommodationDeal.boardType, 'RO');
    const providerId = accommodationDeal.providerId;

    return Odigeo._.extend({}, model.toJSON(), result, {
        key: accommodationDeal.key,
        category: commonParser.getHotelCategory(accommodationInfo.category) || {},
        priceDiscountDynpack: getPriceDiscountData(model.get('isShowPaxDisclaimer'), result),
        hasHotelTypeInfo: commonParser.isValidHotelData(accommodationInfo.type),
        hasHotelRoomsLeft: commonParser.hasHotelRoomsLeft(accommodationDeal.roomsLeft),
        onLoadError: commonParser.getOnLoadError(model.get('noHotelPic')),
        priceColorCssModifier: commonParser.getPriceColorCssModifier(accommodationDeal.roomsLeft),
        nightsText: Odigeo.UIElements.translations.dynpackProduct.pricediscount.perPassenger,
        withPrimeText: Odigeo.UIElements.translations.dynpackProduct.pricediscount.priceWithPrime,
        hotelResultsPhone: Odigeo.UIElements.translations.hotelResultsPhones[0],
        selectedClass: 'select_accommodation',
        hasBoardType: hasBoardType,
        isRoomOnly: isRoomOnly,
        boardTypeIcon: commonParser.getBoardTypeIcon(accommodationDeal.boardType),
        isTrainResultsDesktop: Odigeo.AB.isTrainResultsDesktop,
        bestDeal: bestDeal && Odigeo.AB.isDpPricePerceptionRevamp,
        providerId: providerId,
    });
}

module.exports = {
    getResultData,
    getFilterTagsData,
};
